import { action } from 'mobx';
import { API } from 'aws-amplify';
import { Bloodwork, BloodworkRange } from '../models';
import moment from 'moment';
const uuidv4 = require('uuid/v4');

export class BloodworkStore {
  @action async load(clientId?: string, limit?: number, lastCreateDate?: string): Promise<any> {
    //console.log('***************** loadBloodworks **********************************');
    const init = {
      queryStringParameters: {
          clientId,
          limit,
          lastCreateDate
      }
    };
    return new Promise<any>(
      (resolve) => API.get('restAPI', '/bloodwork/practitioner', init).then(data => {
        console.log(data);
        const bloodworkEntries = clientId ? data : data.Items;
        console.log(bloodworkEntries);
        let bloodworks = [];
        if (bloodworkEntries) {
          bloodworks = bloodworkEntries.map((bloodwork: Bloodwork) => {
            return new Bloodwork(bloodwork);
          });
        }

        data.bloodworks = bloodworks;
        data.Items = undefined;
        const results = clientId ? bloodworks : data;
        resolve(results);
      }
    ).catch((error) => {
      console.log(error);
      Promise.reject(error);
    }));
  }

  async loadBloodworkRanges(): Promise<BloodworkRange[]> {
    return new Promise<BloodworkRange[]>(
      (resolve) => API.get('restAPI', '/bloodworkRange', {}).then(bloodworkRanges => {
        const newBloodworkRanges = BloodworkRange.bloodworkRangesFrom(bloodworkRanges);
        //console.log('********************************* BLOODWORK RANGES ************');
        //console.log(JSON.stringify(newBloodworkRanges, null, 2));  
        resolve(newBloodworkRanges);
      }
    ).catch((error) => {
      console.error(error);
      Promise.reject(error);
    }));
  }

  async saveBloodwork(bloodwork: Bloodwork): Promise<Bloodwork> {
    const isNew = bloodwork.isNew();
    const currentDate = moment().toISOString(true);
    if (isNew) {
      bloodwork.id = uuidv4();
      bloodwork.createDate = currentDate;
    } 
    bloodwork.lastModifiedDate = currentDate;

    let requestParams = {
      body : bloodwork
    };

    return new Promise<Bloodwork>(
      (resolve, reject) => API.post('restAPI', '/bloodwork/practitioner', requestParams).then(response => {
        console.log(response);
        const savedBloodwork: Bloodwork = new Bloodwork(response);
        resolve(savedBloodwork);
      }).catch((error) => {
        console.error(error);
        if (isNew) {
          bloodwork.id = undefined;
          bloodwork.createDate = undefined;
          bloodwork.lastModifiedDate = undefined;
        }
        reject(error);
      }));
  }

  async deleteBloodwork(bloodwork: Bloodwork): Promise<any> {
    const init = {
      queryStringParameters: bloodwork.key()
    };
    console.log(init);
    return await API.del('restAPI', '/bloodwork', init);
  }
}